import {action, extendObservable} from "mobx";
import FormService from "../../../core/services/FormService";
import {isRequired} from "../../../core/validations";
import NotificationService from "../../../core/services/NotificationService";
import FetchService from "../../../core/services/FetchService";
import ConfirmationDialogService from "../../../core/services/ConfirmationDialogService";

export class SystemTranslationLocaleService {

    form = new FormService();
    submit = new FetchService();
    fetch = new FetchService();

    constructor() {
        extendObservable(this, {
            locale: {},
            locales: [],
            formOpened: false,
        });
        this.form.validations = {
            key: [isRequired],
            language: [isRequired],
        }
        this.form.setInitialValues({
            key: '',
            language: '',
        });
    }

    load = action(() => {
        this.fetch.fetch({
            url: '/locales?verbose=true'
        }).then(() => {
            this.locales = this.fetch.data;
        })
    });

    handleSubmit = action(() => {
        this.form.submitted = true;
        if(this.form.errors) {
            NotificationService.addNotification('Fill the required fields', 'error');
            return;
        }
        const localeId = this.form.getValue('id');
        this.submit.fetch({
            method: localeId ? 'put' : 'post',
            url: localeId ? `/locales/${localeId}` : '/locales',
            body: this.form.getValues(),
        }).then(() => {
            if(this.submit.data) {
                this.load();
                NotificationService.addNotification(`Locale ${localeId ? 'updated' : 'created'} successfully.`, 'success');
                this.closeForm();
            } else if(this.submit.response.status === 400) {
                NotificationService.addNotification(this.submit.response.data.error, 'error');
            } else {
                NotificationService.addNotification(`Error ${localeId ? 'updating' : 'creating'} locale.`, 'error');
            }
        });
    });

    openForm = action((locale) => {
        if(locale) {
            this.locale = locale;
            this.form.setInitialValues(locale);
        }
        this.formOpened = true;
    });

    closeForm = action(() => {
        this.formOpened = false;
        this.form.reset();
    });

    handleDelete = action((locale) => {
        ConfirmationDialogService.show(
            'Delete Locale',
            `You are about to delete the Locale "${locale.key} (${locale.language})", Do you want to continue ?`,
            () => {
                this.fetch.fetch({
                    url: `/locales/${locale.id}`,
                    method: 'delete',
                }).then(() => {
                    if (this.fetch.data) {
                        NotificationService.addNotification(`Locale "${locale.key} (${locale.language})" deleted successfully.`, 'success');
                        this.load();
                    }
                    if (this.fetch.error) {
                        NotificationService.addNotification(this.fetch.error, 'error');
                    }
                });
            });

    });

}

const systemTranslationLocaleService = new SystemTranslationLocaleService();

export default systemTranslationLocaleService;